import React, { useEffect, useState } from 'react';
import { Heart, Grid, Network, BarChart2, Settings } from 'lucide-react';
function formatNumber(num: number): string {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return num.toString();
}
interface BottomNavProps {
  currentTab: string;
  onTabChange: (tab: string) => void;
}
export function BottomNav({
  currentTab,
  onTabChange
}: BottomNavProps) {
  const [nickLikes, setNickLikes] = useState(0);
  const [showHeartAnimation, setShowHeartAnimation] = useState(false);
  const [showCounter, setShowCounter] = useState(false);
  // Load likes from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem('nickLikes');
    if (stored) {
      const count = parseInt(stored, 10);
      setNickLikes(count);
      if (count > 0) {
        setShowCounter(true);
      }
    }
  }, []);
  // Auto-hide counter after 3 seconds
  useEffect(() => {
    if (showCounter && nickLikes > 0) {
      const timer = setTimeout(() => {
        setShowCounter(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showCounter, nickLikes]);
  const handleHeartClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const newCount = nickLikes + 1;
    setNickLikes(newCount);
    localStorage.setItem('nickLikes', newCount.toString());
    // Show counter and trigger animation
    setShowCounter(true);
    setShowHeartAnimation(true);
    setTimeout(() => setShowHeartAnimation(false), 600);
  };
  return <div className="fixed bottom-0 left-0 w-full max-w-[400px] bg-gradient-to-t from-slate-200 to-slate-50 backdrop-blur-md pb-6 pt-2 px-6 flex justify-between items-end z-50 pointer-events-auto border-t border-slate-300 shadow-[0_-4px_12px_rgba(15,23,42,0.12)]" data-id="element-105">
      <button onClick={handleHeartClick} className="flex flex-col items-center gap-1 text-gray-400 hover:text-red-500 transition-colors relative group active:scale-95 w-16" type="button" data-id="element-106">
        {/* Counter Badge */}
        {nickLikes > 0 && <div className={`absolute -top-8 left-1/2 -translate-x-1/2 bg-red-500 text-white text-xs font-bold px-2.5 py-1 rounded-full shadow-lg min-w-[28px] text-center transition-opacity duration-500 ${showCounter ? 'opacity-100' : 'opacity-0'}`} data-id="element-107">
            {formatNumber(nickLikes)}
          </div>}

        {/* Heart Icon Container - matching other tabs */}
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" data-id="element-108">
          <div className="relative w-6 h-6 flex items-center justify-center" data-id="element-109">
            <Heart className={`w-6 h-6 transition-all duration-300 ${showHeartAnimation ? 'scale-125 fill-red-500 text-red-500' : 'group-hover:fill-red-400 group-hover:text-red-400'}`} data-id="element-110" />

            {/* Floating Hearts Animation */}
            {showHeartAnimation && <>
                <Heart className="w-4 h-4 fill-red-400 text-red-400 absolute top-0 left-0 animate-ping" data-id="element-111" />
                <Heart className="w-3 h-3 fill-red-300 text-red-300 absolute -top-2 left-1 animate-bounce" style={{
              animationDelay: '100ms'
            }} data-id="element-112" />
              </>}
          </div>
        </div>

        <span className="text-[10px] font-medium" data-id="element-113">I ♥ Nick</span>
      </button>

      <button onClick={() => onTabChange('call')} className={`flex flex-col items-center gap-1 transition-colors w-16 ${currentTab === 'call' ? 'text-black' : 'text-gray-400 hover:text-gray-600'}`} type="button" data-id="element-114">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${currentTab === 'call' ? 'bg-white shadow-sm' : ''}`} data-id="element-115">
          <Grid className="w-6 h-6" data-id="element-116" />
        </div>
        <span className="text-[10px] font-medium" data-id="element-117">Call</span>
      </button>

      <button onClick={() => onTabChange('reps-score')} className={`flex flex-col items-center gap-1 transition-colors w-16 ${currentTab === 'reps-score' ? 'text-black' : 'text-gray-400 hover:text-gray-600'}`} type="button" data-id="element-118">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${currentTab === 'reps-score' ? 'bg-white shadow-sm' : ''}`} data-id="element-119">
          <Network className="w-6 h-6" data-id="element-120" />
        </div>
        <span className="text-[10px] font-medium" data-id="element-121">Rep's Score</span>
      </button>

      <button onClick={() => onTabChange('leader-board')} className={`flex flex-col items-center gap-1 transition-colors w-16 ${currentTab === 'leader-board' ? 'text-black' : 'text-gray-400 hover:text-gray-600'}`} type="button" data-id="element-122">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${currentTab === 'leader-board' ? 'bg-white shadow-sm' : ''}`} data-id="element-123">
          <BarChart2 className="w-6 h-6" data-id="element-124" />
        </div>
        <span className="text-[10px] font-medium" data-id="element-125">Top Czar</span>
      </button>

      <button onClick={() => onTabChange('settings')} className={`flex flex-col items-center gap-1 transition-colors w-16 ${currentTab === 'settings' ? 'text-black' : 'text-gray-400 hover:text-gray-600'}`} type="button" data-id="element-126">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${currentTab === 'settings' ? 'bg-white shadow-sm' : ''}`} data-id="element-127">
          <Settings className="w-6 h-6" data-id="element-128" />
        </div>
        <span className="text-[10px] font-medium" data-id="element-129">Settings</span>
      </button>
    </div>;
}